module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "SOM"
  }, [_c('h1', {
    staticClass: "SOM_titre"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "#/chap2"
    }
  }, [_vm._v("Introduction: How Did We Get Here?"), _c('br'), _c('i', [_vm._v("Hugh Ross, Deborah Haarsma, and Kenneth Keathley")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap3"
    }
  }, [_vm._v("1 Boundaries: What Views Define Your Organization?"), _c('br'), _c('i', [_vm._v("Robert Stewart, Deborah Haarsma, Hugh Ross, and Kenneth Samples")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Biblical Interpretation: What Is the Nature of Biblical Authority?"), _c('br'), _c('i', [_vm._v("Steve Lemke, John Walton, and Kenneth Samples")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 The Original Couple: What Is the Range of Viable Positions Concerning Adam and Eve?"), _c('br'), _c('i', [_vm._v("Ted Cabal, Loren Haarsma, and Kenneth Samples")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Death, Predation, and Suffering: Is “Natural Evil” Evil?"), _c('br'), _c('i', [_vm._v("James Dew, J. B. Stump, and Hugh Ross")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Divine Action: How Does God Interact with the Natural World?"), _c('br'), _c('i', [_vm._v("John Laing, J. B. Stump, and Jeff Zweerink")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 The Scientific Method: Methodological Naturalism or Natural Theology?"), _c('br'), _c('i', [_vm._v("James Dew, J. B. Stump, and Jeff Zweerink")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Biological Evolution: What Is It? Does It Explain Life’s History?"), _c('br'), _c('i', [_vm._v("Ted Cabal, Darrel Falk, and Fuz Rana")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 The Geological Evidence: What Is the Natural History of the Earth and the Origin of Life?"), _c('br'), _c('i', [_vm._v("Robert Stewart, Ralph Stearley, and Hugh Ross")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 The Fossil Evidence: Who Were the Hominids?"), _c('br'), _c('i', [_vm._v("Robert Stewart, Ralph Stearley, and Fuz Rana")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 The Biological Evidence: Does Genetics Point to Common Descent?"), _c('br'), _c('i', [_vm._v("John Laing, Darrel Falk, and Fuz Rana")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 The Anthropological Evidence: How Are Humans Unique?"), _c('br'), _c('i', [_vm._v("Steve Lemke, Jeff Schloss, and Fuz Rana")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: What Is the Next Step?"), _c('br'), _c('i', [_vm._v("Kenneth Keathley, Deborah Haarsma, and Hugh Ross")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The BioLogos Foundation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Old-Earth or Evolutionary Creation?")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Editors")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 60
// module chunks = 0